import React from 'react';

import classes from './Footer.css';
import Button from '../Button/Button';

const footer = (props) => {
  let continueLabel = 'Continua'
  if (props.continueLbl) {
    continueLabel = props.continueLbl
  }
  return (<div className={classes.Footer}>
    <div className={classes.ButtonsContainer}>
      <Button
        btnLabel="Indietro"
        clicked={props.backClick}
        disabledButton={props.backDisabled === true}
        negative
        isBackButton
      />
      <div className={classes.ButtonContinueContainer}>
        {props.nextClick !== null &&
          <Button
            disabledButton={props.continueDisabled}
            btnLabel={continueLabel}
            clicked={props.nextClick}
          />
        }
      </div>
      <div className={classes.ButtonInvisible}>
        <Button
          btnLabel="Indietro"
          clicked={props.backClick}
          negative
          disabledButton
          isBackButton
        />
      </div>
    </div>
  </div>);
}

export default footer;


// WEBPACK FOOTER //
// ./src/components/UI/Footer/Footer.js